<template>
    <div>
        <div class="top-bar">
            <div class="heading_new">
                <span @click="cancelSalaryComponents()">
                <i class="left"></i>
                </span>
                <span class="heading">Variable Salary Components</span>
            </div>
        </div>
        <div class="content">
            <div v-for="component in salaryComponents" :key="component.id">
            <tl-checkbox
                :label="component.name"
                :name="component.id"
                :id="component.id"
                @change="getCheckedItem($event,`${component.name}`)"/>
            </div>
            <bottom-action-container>
            <template slot="end">
                <btn-grp>
                <btn text="Cancel" @click="cancelSalaryComponents()" />
                <btn text="Save" type="primary" @click="saveSalaryComponents()" />
                </btn-grp>
            </template>
            </bottom-action-container>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
export default {
    data() {
        return {
            salaryComponentName: '',
            showSalaryComponents: false,
            salaryComponents: [],
            selectedComponents: [],
            model: {},
        }
    },
    activated() {
       this.getSalaryComponentsData()
   },
   computed: {
       ...mapState({
        salaryComponentsData: state =>
            state.onboard.settings.salary_component.entityWiseData
    }),
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID"
    }),
    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      } else {
        return this.getLegalEntityId(0);
      }

    },
    componentsData() {
    //   let le_id = "f2bd8f30-b270-40b9-942e-7ae917d73781";
      return this.salaryComponentsData[this.leId];
    }
   },
  methods:{
      ...mapActions({
      act_fetchAll: "onboard/settings/salary_component/fetchAll",
    }),
    getSalaryComponentsData() {
        this.salaryComponents = []
        for (let i = 0; i < this.salaryComponentsData[this.leId].length; i++) {
            //console.log('length of array', this.salaryComponentsData[this.leId].length)
            let obj = {}
            obj.name = this.salaryComponentsData[this.leId][i].name
            this.salaryComponentName = this.salaryComponentsData[this.leId][i].name
            obj.id = this.salaryComponentsData[this.leId][i].id
            this.salaryComponents.push(obj)
        }
        //console.log('salary components name',this.salaryComponents);
    },
    cancelSalaryComponents() {
        this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/processfnf`
      });
    },
    getCheckedItem(e, key) {
        //console.log('checkbox value', key)
      this.model[key] = e ? true : false;
      //console.log('model', this.model)
      if(this.model[key] == true){
        this.selectedComponents.push(key)
      }
      //console.log('selected component', this.selectedComponents)
    },
    saveSalaryComponents() {
      this.$emit('selectedComponent', this.selectedComponents)
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/processfnf`
      });
    }
  }
}
</script>

<style lang="scss" langscoped>
.top-bar {
  //   height: auto;
  //   padding: 20px;
  background-color: #34c0be;
  display: flex;
  width: 1341px;
//   margin-left: -30px;
//   margin-top: -30px;
  margin-bottom: 48px;
  height: 85px;
  //   background-color: #34c0be;
}

.heading_new {
  width: auto;
  font-family: Montserrat;
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  height: auto;
  padding: 25px;
}
.left {
  border: solid white;
  border-width: 0 2px 2px 0;
  padding: 5px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  margin-top: 9px;
//   margin-left: 32px;
  margin-right: 39px;
//   margin-top: 8.4%;
  cursor: pointer;
}
.content {
    padding: 20px;
}
</style>
